import React, { Component } from 'react';
import Button10 from '../../components/Button10/Button10';
import Strings from 'localization/Strings';
import './Sound.css';

class Loss extends Component {
    constructor(props){
        super(props);
        this.onSubmit = props.onSubmit;
    }

    render () {
        return (
            <div className='component-card-content '>
                <h4 className="heading1 text-left">{Strings.strings.Sound.Title}</h4>
                <h2 className="display1 text-left pt20">{Strings.strings.Sound.Description}</h2>
                <div className="text-center pt50">
                    <Button10  
                        groups = {Strings.strings.Sound.Groups}
                        onChanged={(selectedValue) => this.onSubmit({user_selection_ssq_clarity: selectedValue})}/>
                </div>
            </div>
        );
    }
}

export default Loss;